import {
  ActivityId,
  ActivitySlug,
  activitySlugMap,
  activitySlugs,
} from '@gyym/sdk'

export const getActivitySlugById = (activityId: ActivityId) => {
  const entry = Object.entries(activitySlugMap).find(
    ([_, v]) => v === activityId,
  )

  return entry ? entry[0] : null
}

export const getActivityIdBySlug = (slug: ActivitySlug) => {
  return activitySlugMap[slug]
}

export const activitySlugExists = (slug: string) => {
  return activitySlugs.includes(slug as ActivitySlug)
}
